var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextH = function SvgIconTextH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 4.25a1 1 0 0 1 1 1V11h11.5V5.25a1 1 0 1 1 2 0v13.5a1 1 0 1 1-2 0V13H6.25v5.75a1 1 0 1 1-2 0V5.25a1 1 0 0 1 1-1"
  })));
};
export default SvgIconTextH;